/* Kids Warehouse theme scripts — scoped to .kw sections */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var money = function (cents) {
    var fmt = (window.kwTheme && window.kwTheme.moneyFormat) || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    var withCommas = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/, withCommas)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','));
  };

  /* ---------- toast ---------- */
  function toast(msg) {
    var t = document.querySelector('[data-kw-toast]');
    if (!t) {
      t = document.createElement('div');
      t.className = 'kw kw-toast';
      t.setAttribute('data-kw-toast', '');
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('kw-show');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('kw-show'); }, 2600);
  }

  /* ---------- cart count ---------- */
  function refreshCartCount(pop) {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-kw-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0 && el.hasAttribute('data-hide-empty');
          if (pop) { el.classList.remove('kw-cart-badge--pop'); void el.offsetWidth; el.classList.add('kw-cart-badge--pop'); }
        });
        return cart;
      }).catch(function () {});
  }

  function addToCart(formData) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) { throw new Error(j.description || j.message || 'Could not add to cart'); }
        return j;
      });
    });
  }

  /* ---------- header ---------- */
  function onScroll() {
    var h = document.querySelector('[data-kw-header]');
    if (h) h.classList.toggle('kw-header--scrolled', window.scrollY > 10);
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------- reveal ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.remove('kw-reveal--hidden');
        e.target.classList.add('kw-reveal--visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }) : null;
  function initReveal(scope) {
    if (!io || (window.Shopify && window.Shopify.designMode)) return;
    (scope || document).querySelectorAll('.kw-reveal:not(.kw-reveal--visible)').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) { el.classList.add('kw-reveal--visible'); return; }
      el.classList.add('kw-reveal--hidden');
      io.observe(el);
    });
  }

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var open = t.closest('[data-kw-drawer-open]');
    if (open) {
      var d = document.getElementById(open.getAttribute('data-kw-drawer-open'));
      if (d) { d.classList.add('kw-is-open'); document.documentElement.style.overflow = 'hidden'; }
      return;
    }
    var close = t.closest('[data-kw-drawer-close]');
    if (close) {
      var dd = close.closest('.kw-drawer, .kw-plp-filters');
      document.querySelectorAll('.kw-drawer.kw-is-open, .kw-plp-filters.kw-is-open, .kw-plp-overlay.kw-is-open').forEach(function (x) { x.classList.remove('kw-is-open'); });
      document.documentElement.style.overflow = '';
      return;
    }
    var fopen = t.closest('[data-kw-filters-open]');
    if (fopen) {
      var sec = fopen.closest('[data-kw-collection]');
      sec.querySelector('.kw-plp-filters').classList.add('kw-is-open');
      sec.querySelector('.kw-plp-overlay').classList.add('kw-is-open');
      return;
    }
    // PDP gallery
    var thumb = t.closest('.kw-pdp-thumb');
    if (thumb) { e.preventDefault(); showMedia(thumb.closest('[data-kw-product-section]'), +thumb.dataset.index); return; }
    var nav = t.closest('.kw-pdp-main__nav');
    if (nav) {
      var s = nav.closest('[data-kw-product-section]');
      var thumbs = s.querySelectorAll('.kw-pdp-thumb');
      var cur = +(s.dataset.mediaIndex || 0);
      var n = thumbs.length || 1;
      showMedia(s, (cur + (nav.classList.contains('kw-pdp-main__nav--next') ? 1 : -1) + n) % n);
      return;
    }
    // qty
    var q = t.closest('[data-kw-qty]');
    if (q) {
      var input = q.closest('.kw-pdp-qty').querySelector('input');
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(q.dataset.kwQty, 10));
      return;
    }
    // size / option buttons
    var opt = t.closest('.kw-pdp-size');
    if (opt) {
      e.preventDefault();
      var group = opt.closest('[data-kw-option-index]');
      group.querySelectorAll('.kw-pdp-size').forEach(function (b) { b.classList.remove('kw-is-selected'); b.setAttribute('aria-checked', 'false'); });
      opt.classList.add('kw-is-selected'); opt.setAttribute('aria-checked', 'true');
      updateVariant(opt.closest('[data-kw-product-section]'));
      return;
    }
    // sticky add -> submit main form
    var sticky = t.closest('[data-kw-sticky-add]');
    if (sticky) {
      var sec2 = sticky.closest('[data-kw-product-section]');
      var f = sec2.querySelector('form[data-kw-product-form]');
      if (f) f.requestSubmit ? f.requestSubmit() : f.dispatchEvent(new Event('submit', { cancelable: true }));
      return;
    }
    // active filter remove / clear (links) -> ajax
    var flink = t.closest('[data-kw-filter-link]');
    if (flink) {
      e.preventDefault();
      var href = flink.href;
      if (flink.hasAttribute('data-kw-keep-query')) {
        var q = new URLSearchParams(window.location.search); q.delete('page');
        if (q.toString()) href += (href.indexOf('?') > -1 ? '&' : '?') + q.toString();
      }
      loadCollection(flink.closest('[data-kw-collection]'), href);
      return;
    }
    // load more
    var more = t.closest('[data-kw-load-more]');
    if (more) { e.preventDefault(); loadMore(more); return; }
  });

  /* ---------- forms ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches('form[data-kw-quick-add]')) {
      e.preventDefault();
      var btn = f.querySelector('button');
      var label = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
      addToCart(new FormData(f)).then(function () {
        btn.textContent = 'Added'; toast('Added to cart'); refreshCartCount(true);
      }).catch(function (err) { toast(err.message); btn.textContent = label; })
        .finally(function () { setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1600); });
      return;
    }
    if (f.matches('form[data-kw-product-form]')) {
      e.preventDefault();
      var sec = f.closest('[data-kw-product-section]');
      var err = sec.querySelector('[data-kw-error]');
      var btns = sec.querySelectorAll('.kw-pdp-add');
      btns.forEach(function (b) { b.disabled = true; b.dataset.label = b.textContent; b.textContent = 'Adding…'; });
      if (err) err.hidden = true;
      addToCart(new FormData(f)).then(function (item) {
        toast('Added to cart: ' + (item.variant_title ? item.product_title + ' – ' + item.variant_title : item.product_title));
        refreshCartCount(true);
      }).catch(function (x) {
        if (err) { err.textContent = x.message; err.hidden = false; } else { toast(x.message); }
      }).finally(function () {
        btns.forEach(function (b) { b.textContent = b.dataset.label; });
        updateVariant(sec);
      });
      return;
    }
    if (f.matches('form[data-kw-filter-form]')) {
      e.preventDefault();
      loadCollection(f.closest('[data-kw-collection]'), urlFromForm(f));
    }
  });

  document.addEventListener('change', function (e) {
    var f = e.target.closest('form[data-kw-filter-form]');
    if (f && e.target.type !== 'number') { loadCollection(f.closest('[data-kw-collection]'), urlFromForm(f)); return; }
    if (e.target.matches('[data-kw-sort]')) {
      var sec = e.target.closest('[data-kw-collection]');
      var form = sec.querySelector('form[data-kw-filter-form]');
      var hidden = form.querySelector('input[name=sort_by]');
      hidden.value = e.target.value;
      loadCollection(sec, urlFromForm(form));
    }
  });

  /* ---------- PDP ---------- */
  function productData(sec) {
    if (!sec._kwData) {
      var j = sec.querySelector('script[data-kw-product-json]');
      sec._kwData = j ? JSON.parse(j.textContent) : null;
    }
    return sec._kwData;
  }
  function showMedia(sec, i) {
    var thumbs = sec.querySelectorAll('.kw-pdp-thumb');
    var main = sec.querySelector('[data-kw-main-img]');
    var th = thumbs[i];
    if (!th || !main) return;
    sec.dataset.mediaIndex = i;
    thumbs.forEach(function (x) { x.classList.remove('kw-is-active'); });
    th.classList.add('kw-is-active');
    main.style.opacity = '0.3';
    var img = new Image();
    img.onload = function () { main.src = th.dataset.src; main.srcset = th.dataset.srcset || ''; main.alt = th.dataset.alt || main.alt; main.style.opacity = '1'; };
    img.src = th.dataset.src;
  }
  function updateVariant(sec) {
    if (!sec) return;
    var data = productData(sec); if (!data) return;
    var selected = [];
    sec.querySelectorAll('[data-kw-option-index]').forEach(function (g) {
      var b = g.querySelector('.kw-is-selected');
      selected[+g.dataset.kwOptionIndex] = b ? b.dataset.value : null;
      var lab = g.querySelector('[data-kw-option-selected]'); if (lab && b) lab.textContent = b.dataset.value;
    });
    var v = data.variants.find(function (vv) {
      return vv.options.every(function (o, i) { return selected[i] == null || selected[i] === o; });
    });
    // availability styling for single-option products
    if (data.options.length === 1) {
      sec.querySelectorAll('.kw-pdp-size').forEach(function (b) {
        var vv = data.variants.find(function (x) { return x.options[0] === b.dataset.value; });
        b.classList.toggle('kw-is-unavailable', !vv || !vv.available);
      });
    }
    var idInput = sec.querySelector('input[name=id]');
    var addBtns = sec.querySelectorAll('.kw-pdp-add');
    var stock = sec.querySelector('[data-kw-stock]');
    if (!v) {
      addBtns.forEach(function (b) { b.disabled = true; b.textContent = 'Unavailable'; });
      if (stock) { stock.textContent = 'This combination is unavailable'; stock.className = 'kw-pdp-stock kw-pdp-stock--out'; }
      return;
    }
    if (idInput) idInput.value = v.id;
    sec.querySelectorAll('[data-kw-price]').forEach(function (el) { el.textContent = money(v.price); });
    var was = sec.querySelector('[data-kw-compare]');
    var save = sec.querySelector('[data-kw-save]');
    if (was) {
      var on = v.compare_at_price && v.compare_at_price > v.price;
      was.hidden = !on; if (on) was.textContent = money(v.compare_at_price);
      if (save) { save.hidden = !on; if (on) save.textContent = 'Save ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
    }
    var sku = sec.querySelector('[data-kw-sku]');
    if (sku) { sku.textContent = v.sku || ''; sku.closest('[data-kw-sku-wrap]').hidden = !v.sku; }
    sec.querySelectorAll('[data-kw-sticky-variant]').forEach(function (el) { el.textContent = v.title; });
    var low = parseInt(sec.dataset.lowStock || '0', 10);
    addBtns.forEach(function (b) {
      b.disabled = !v.available;
      b.textContent = v.available ? (b.dataset.addLabel || 'Add to Cart') : (b.dataset.soldLabel || 'Sold Out');
    });
    var bn = sec.querySelector('.kw-pdp-buynow-wrap'); if (bn) bn.style.display = v.available ? '' : 'none';
    if (stock) {
      if (!v.available) { stock.textContent = stock.dataset.out; stock.className = 'kw-pdp-stock kw-pdp-stock--out'; }
      else if (low && v.inventory_management && v.qty != null && v.qty > 0 && v.qty <= low) { stock.textContent = stock.dataset.low.replace('[count]', v.qty); stock.className = 'kw-pdp-stock kw-pdp-stock--low'; }
      else { stock.textContent = stock.dataset.in; stock.className = 'kw-pdp-stock'; }
    }
    if (v.featured_media_index != null) showMedia(sec, v.featured_media_index);
    if (window.history.replaceState && sec.dataset.updateUrl === 'true') {
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', u.toString());
    }
  }
  function initProduct(scope) {
    (scope || document).querySelectorAll('[data-kw-product-section]').forEach(function (sec) {
      sec._kwData = null;
      updateVariant(sec);
      var sticky = sec.querySelector('.kw-pdp-sticky');
      var mainAdd = sec.querySelector('.kw-pdp-buy');
      if (sticky && mainAdd && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          sticky.classList.toggle('kw-is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
        }).observe(mainAdd);
      }
    });
  }

  /* ---------- related products ---------- */
  function initRecs(scope) {
    (scope || document).querySelectorAll('[data-kw-recs]').forEach(function (el) {
      if (el.dataset.loaded) return; el.dataset.loaded = '1';
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-kw-recs]');
        if (inner && inner.querySelector('.kw-product-card')) { el.innerHTML = inner.innerHTML; initReveal(el); }
        else { var s = el.closest('.shopify-section'); if (s) s.style.display = 'none'; }
      }).catch(function () {});
    });
  }

  /* ---------- collection ---------- */
  function urlFromForm(f) {
    var fd = new FormData(f);
    var p = new URLSearchParams();
    fd.forEach(function (v, k) { if (v !== '') p.append(k, v); });
    return f.action.split('?')[0] + (p.toString() ? '?' + p.toString() : '');
  }
  function loadCollection(sec, url) {
    if (!sec) { window.location.href = url; return; }
    var grid = sec.querySelector('.kw-plp-grid'); if (grid) grid.classList.add('kw-is-loading');
    var sid = sec.dataset.sectionId;
    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sid;
    fetch(fetchUrl).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-kw-collection]');
      if (!fresh) { window.location.href = url; return; }
      var wasOpen = sec.querySelector('.kw-plp-filters.kw-is-open');
      sec.innerHTML = fresh.innerHTML;
      if (wasOpen && window.innerWidth <= 900) { sec.querySelector('.kw-plp-filters').classList.add('kw-is-open'); sec.querySelector('.kw-plp-overlay').classList.add('kw-is-open'); }
      history.pushState({ kw: true }, '', url);
    }).catch(function () { window.location.href = url; });
  }
  function loadMore(btn) {
    var sec = btn.closest('[data-kw-collection]');
    btn.classList.add('kw-is-loading'); var label = btn.textContent; btn.textContent = 'Loading…';
    var url = btn.href + (btn.href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sec.dataset.sectionId;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var cards = tmp.querySelectorAll('.kw-plp-grid > .kw-product-card');
      var grid = sec.querySelector('.kw-plp-grid');
      cards.forEach(function (c) { grid.appendChild(c); });
      var newMore = tmp.querySelector('.kw-plp-more');
      var oldMore = sec.querySelector('.kw-plp-more');
      if (newMore && oldMore) oldMore.replaceWith(newMore);
      var shown = tmp.querySelector('[data-kw-shown]');
      var shownEl = sec.querySelector('[data-kw-shown]');
      if (shownEl) shownEl.textContent = grid.querySelectorAll('.kw-product-card').length;
    }).catch(function () { window.location.href = btn.href; })
      .finally(function () { btn.classList.remove('kw-is-loading'); btn.textContent = label; });
  }
  window.addEventListener('popstate', function (e) { if (e.state && e.state.kw) window.location.reload(); });

  /* ---------- init ---------- */
  function init(scope) { onScroll(); initReveal(scope); initProduct(scope); initRecs(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.kwRefreshCartCount = refreshCartCount;
})();
